import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import Hls from 'hls.js';
// import { signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { WsService } from '../services/ws.service';
 
 
@Component({
  selector: 'app-live',
  templateUrl: './live.component.html',
  styleUrls: ['./live.component.css']
})
export class LiveComponent implements OnInit {
 
  @ViewChild('video', { static: true }) videoEl!: ElementRef<HTMLVideoElement>;
  @ViewChild('overlay', { static: true }) overlayEl!: ElementRef<HTMLCanvasElement>;
 
  selectedFiles: File[] = [];
  objectId = '';
  objectLabel = '';
 
  cameraId!: string;
  hls?: Hls;
  wsSub: any;
 
  alerts: any = [];
  showModal: any = [];
 
  // detections & thumbnails (all detections kept as before)
  latestDetections: any =[];
  detPollSub?: Subscription;
 
  // tracked (manually selected) ids - draw only these on video overlay
  trackedIds: any = [];
 
  // Drawing state (overlay)
  private drawing = false;
  private startX = 0;
  private startY = 0;
  private curX = 0;
  private curY = 0;
  private drawConfirmed = false;
 
  constructor(private route: ActivatedRoute, private router: Router, private api: ApiService, private ws: WsService) { }
 
  ip = '';
  username = '';
  password = '';
  channelId = '';
 
  streaming = false;
 
  ngOnInit() {
    // this.cameraId = this.route.snapshot.params['id'];
    // this.startStream();
    // this.openTrackPrompt();
    this.setupWebsocket();
    // setTimeout(() => this.startDetectionsPolling(), 500);
 
    // // attach pointer events for drawing on overlay
    // setTimeout(() => this.initOverlayEvents(), 200);
  }
 
  async startStream() {
    try {
      this.cameraId = `${this.ip}_${this.channelId}`;
 
      const res: any = await this.api.startStream({
        // ip: this.ip,
        // username: this.username,
        // password: this.password,
        // channel_id: this.channelId
        channel_id : "1",
        ip : "183.82.148.242",
        password : "CAKE@Vishwa1204",
        username : "admin"
      }).toPromise();
      this.setupWebsocket();
      setTimeout(() => this.startDetectionsPolling(), 500);
 
      // attach pointer events for drawing on overlay
      setTimeout(() => this.initOverlayEvents(), 200);
      const m3u8Path = res?.m3u8;
      if (!m3u8Path) throw new Error("Backend did not return m3u8");
      let backendOrigin = (this.api as any).base;
      if (backendOrigin.endsWith('/api')) backendOrigin = backendOrigin.slice(0, -4);
      if (backendOrigin.endsWith('/api/')) backendOrigin = backendOrigin.slice(0, -5);
      const playlist = `${backendOrigin}${m3u8Path}`;
      const video = this.videoEl.nativeElement;
      if (Hls.isSupported()) {
        this.hls = new Hls({ enableWorker: true, lowLatencyMode: true });
        this.hls.attachMedia(video);
        this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
          this.hls!.loadSource(playlist);
          // this.hls!.on(Hls.Events.MANIFEST_PARSED, () => video.play());
          this.hls!.on(Hls.Events.MANIFEST_PARSED, () => {
            video.muted = true;
 
            const tryPlay = () => {
              if (video.clientWidth > 0 && video.clientHeight > 0) {
                video.play().catch(() => { });
              } else {
                requestAnimationFrame(tryPlay);
              }
            };
 
            tryPlay();
          });
 
        });
      } else if (video.canPlayType && video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = playlist;
        video.onloadedmetadata = () => video.play();
      } else {
        // if environment doesn't have alert (SSR) skip
        try { alert("HLS not supported"); } catch { }
      }
      video.addEventListener('loadedmetadata', () => {
        this.applyVideoAspectRatio();
        this.resizeOverlay();
      });
      video.addEventListener('loadeddata', () => {
        video.play().catch(() => { });
      });
 
      window.addEventListener('resize', () => {
        this.applyVideoAspectRatio();
        this.resizeOverlay();
      });
      this.streaming = true;
    } catch (err) {
      console.error(err);
      try { alert("Could not start stream"); } catch { }
    }
  }
 
  // overlay drawing init
  initOverlayEvents() {
    const canvas = this.overlayEl?.nativeElement;
    if (!canvas) return;
    // enable pointer events to draw
    canvas.style.pointerEvents = 'auto';
 
    canvas.addEventListener('pointerdown', (ev: PointerEvent) => this.onPointerDown(ev));
    canvas.addEventListener('pointermove', (ev: PointerEvent) => this.onPointerMove(ev));
    canvas.addEventListener('pointerup', (ev: PointerEvent) => this.onPointerUp(ev));
    canvas.addEventListener('pointerleave', (ev: PointerEvent) => this.onPointerUp(ev));
  }
 
  onPointerDown(ev: PointerEvent) {
    // start drawing only with left button (or you can check modifiers)
    if (ev.button !== 0) return;
    const canvas = this.overlayEl.nativeElement;
    const rect = canvas.getBoundingClientRect();
    this.drawing = true;
    this.drawConfirmed = false;
    this.startX = ev.clientX - rect.left;
    this.startY = ev.clientY - rect.top;
    this.curX = this.startX;
    this.curY = this.startY;
  }
 
  onPointerMove(ev: PointerEvent) {
    if (!this.drawing) return;
    const canvas = this.overlayEl.nativeElement;
    const rect = canvas.getBoundingClientRect();
    this.curX = Math.max(0, Math.min(ev.clientX - rect.left, canvas.width));
    this.curY = Math.max(0, Math.min(ev.clientY - rect.top, canvas.height));
    this.renderOverlay(); // draw temporary rect
  }
 
  async onPointerUp(ev: PointerEvent) {
    if (!this.drawing) return;
    this.drawing = false;
    this.drawConfirmed = true;
    this.renderOverlay(); // final rect
    // automatically try to select: convert to frame coords and call backend
    await this.confirmSelection();
  }
 
  // convert displayed canvas coords to FRAME coords and call backend
  async confirmSelection() {
    const video = this.videoEl.nativeElement;
    const canvas = this.overlayEl.nativeElement;
    if (!video || !canvas) return;
 
    // compute rect in canvas/display pixels
    const x1 = Math.round(Math.min(this.startX, this.curX));
    const y1 = Math.round(Math.min(this.startY, this.curY));
    const x2 = Math.round(Math.max(this.startX, this.curX));
    const y2 = Math.round(Math.max(this.startY, this.curY));
    if (x2 - x1 < 8 || y2 - y1 < 8) {
      // too small
      this.drawConfirmed = false;
      this.renderOverlay();
      return;
    }
 
    // video.videoWidth/video.videoHeight are the frame dimensions
    const frameW = video.videoWidth || 1280;
    const frameH = video.videoHeight || 720;
 
    // canvas width/height correspond to client display size; mapping:
    const scaleX = frameW / canvas.clientWidth;
    const scaleY = frameH / canvas.clientHeight;
 
    const frameBox: [number, number, number, number] = [
      Math.round(x1 * scaleX),
      Math.round(y1 * scaleY),
      Math.round(x2 * scaleX),
      Math.round(y2 * scaleY),
    ];
 
    try {
      const res: any = await this.api.selectBoxForMonitor(this.cameraId, frameBox).toPromise();
      if (res?.status === 'ok') {
        const id = res.selected_id;
        // add locally too
        const arr = [...this.trackedIds()];
        if (!arr.includes(id)) arr.push(id);
        this.trackedIds.set(arr);
        this.showToast('Tracking set', `Selected id=${id}`);
        setTimeout(() => this.startDetectionsPolling(), 500);
 
        // attach pointer events for drawing on overlay
        setTimeout(() => this.initOverlayEvents(), 200);
      } else {
        this.showToast('Selection', 'Select request failed or no worker');
      }
    } catch (e) {
      console.error('selectBox error', e);
      this.showToast('Selection', 'Select request failed');
    } finally {
      // clear the drawn rect display after selection attempt (or you may keep it)
      this.drawConfirmed = false;
      this.renderOverlay();
    }
  }
 
  private detSub?: Subscription;
 
  startDetectionsPolling() {
    if (this.detSub) return;
 
    this.detSub = this.ws.connectDetections(this.ip + '_' + this.channelId).subscribe(payload => {
      console.log('WS DET:', payload);
      this.latestDetections.set(payload?.results || []);
      this.drawDetections();
    });
  }
 
  stopDetectionsPolling() {
    this.detSub?.unsubscribe();
    this.detSub = undefined;
  }
 
  // draw overlay boxes (only for trackedIds)
  drawDetections() {
    const canvas = this.overlayEl?.nativeElement;
    const video = this.videoEl?.nativeElement;
    if (!canvas || !video) return;
    const ctx = canvas.getContext('2d')!;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
 
    const vW = video.videoWidth || 1280;
    const vH = video.videoHeight || 720;
    const cW = canvas.width, cH = canvas.height;
    const scaleX = cW / vW;
    const scaleY = cH / vH;
 
    ctx.lineWidth = 2;
    ctx.font = '14px Arial';
 
    const tracked = new Set(this.trackedIds());
 
    for (const d of this.latestDetections()) {
      if (!d.bbox) continue;
      if (!d.id || !tracked.has(d.id)) continue; // only draw selected/tracked ids
 
      const [x1, y1, x2, y2] = d.bbox.map((v: any) => Number(v));
      const sx = Math.round(x1 * scaleX);
      const sy = Math.round(y1 * scaleY);
      const sw = Math.round((x2 - x1) * scaleX);
      const sh = Math.round((y2 - y1) * scaleY);
 
      ctx.strokeStyle = 'red';
      ctx.fillStyle = 'red';
      ctx.strokeRect(sx, sy, sw, sh);
      const txt = `${d.label}${d.id ? ` #${d.id}` : ''}`;
      ctx.fillText(txt, sx + 4, sy + 14);
    }
  }
 
  // temporary render overlay (draw live drawing rectangle)
  renderOverlay() {
    const canvas = this.overlayEl?.nativeElement;
    const video = this.videoEl?.nativeElement;
    if (!canvas || !video) return;
    const ctx = canvas.getContext('2d')!;
    // first draw tracked boxes
    this.drawDetections();
 
    if (this.drawing || this.drawConfirmed) {
      const x = Math.min(this.startX, this.curX);
      const y = Math.min(this.startY, this.curY);
      const w = Math.abs(this.curX - this.startX);
      const h = Math.abs(this.curY - this.startY);
      ctx.save();
      ctx.lineWidth = 2;
      ctx.setLineDash([6, 4]);
      ctx.strokeStyle = 'cyan';
      ctx.strokeRect(x, y, w, h);
      ctx.restore();
    }
  }
 
  resizeOverlay() {
    const video = this.videoEl.nativeElement;
    const canvas = this.overlayEl.nativeElement;
    if (!video || !canvas) return;
 
    canvas.width = video.clientWidth;
    canvas.height = video.clientHeight;
 
    this.drawDetections();
  }
 
  private applyVideoAspectRatio() {
    const video = this.videoEl.nativeElement;
    const container = video.parentElement as HTMLElement;
    if (!video || !container) return;
 
    const vw = video.videoWidth;
    const vh = video.videoHeight;
    if (!vw || !vh) return;
 
    // 960x1080 => ~0.888
    const aspect = vw / vh;
 
    const containerWidth = container.clientWidth;
    const displayHeight = Math.round(containerWidth / aspect);
 
    video.style.width = `${containerWidth}px`;
    video.style.height = `${displayHeight}px`;
  }
 
  // When user clicks thumbnail to select tracking target (unchanged)
  async selectThumbnail(det: any) {
    if (!det || !det.id) {
      try { alert('Invalid selection'); } catch { }
      return;
    }
    try {
      await this.api.setMonitorTargets(this.cameraId, [{ id: det.id, label: det.label }]).toPromise();
      // also update local trackedIds
      const arr = [...this.trackedIds()];
      if (!arr.includes(det.id)) arr.push(det.id);
      this.trackedIds.set(arr);
      this.showToast('Tracking set', `Tracking ${det.label} id=${det.id}`);
    } catch (e) {
      console.error(e);
      try { alert('Failed to set monitor'); } catch { }
    }
  }
 
  setupWebsocket() {
    const subject = this.ws.connectAlerts(this.cameraId);
    this.wsSub = subject.subscribe((payload: any) => {
      this.showToast(`${payload.label}`, payload.message);
    });
  }
 
  showToast(title: string, message?: string) {
    const id = Date.now() + Math.floor(Math.random() * 1000);
    const entry = { id, title, message, ts: new Date().toISOString() };
    this.alerts.set([entry, ...this.alerts()]);
    setTimeout(() => this.alerts.set(this.alerts().filter((e: any) => e.id !== id)), 5000);
  }
 
  async stop() {
    await this.api.stopStream({
      ip: this.ip,
      username: this.username,
      password: this.password,
      channel_id: this.channelId
    }).toPromise().catch(() => { });
    if (this.hls) this.hls.destroy();
    if (this.wsSub) this.wsSub.unsubscribe();
    this.stopDetectionsPolling();
    this.streaming = false;
    // this.router.navigate(['/devices']);
  }
 
  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;
 
    this.selectedFiles = Array.from(input.files);
  }
 
  async uploadObjectImages() {
    if (!this.cameraId || !this.objectId || !this.objectLabel || this.selectedFiles.length === 0) {
      this.showToast('Upload failed', 'Missing fields or images');
      return;
    }
 
    try {
      const res: any = await this.api
        .registerObject(
          this.cameraId,
          this.objectId,
          this.objectLabel,
          this.selectedFiles
        )
        .toPromise();
 
      if (res?.status === 'ok') {
        this.showToast(
          'Object registered',
          `ID: ${res.object_id}`
        );
        this.selectedFiles = [];
      } else {
        this.showToast('Upload failed', 'Backend error');
      }
    } catch (err) {
      console.error(err);
      this.showToast('Upload failed', 'Request error');
    }
  }
 
  ngOnDestroy() {
    if (this.streaming) this.stop();
  }
}
 
 